module.exports = __webpack_public_path__ + "static/media/Mema rebrand logo.ed006a3b.jpeg";